import { render, staticRenderFns } from "./FlowFormExtraPropSet.vue?vue&type=template&id=23c7865a&scoped=true&"
import script from "./FlowFormExtraPropSet.vue?vue&type=script&lang=js&"
export * from "./FlowFormExtraPropSet.vue?vue&type=script&lang=js&"
import style0 from "./FlowFormExtraPropSet.vue?vue&type=style&index=0&id=23c7865a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c7865a",
  null
  
)

export default component.exports